import { render, staticRenderFns } from "./UpdateCommitBound.vue?vue&type=template&id=3ef0adce"
import script from "./UpdateCommitBound.vue?vue&type=script&lang=js"
export * from "./UpdateCommitBound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports